'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = removeSelectedRange;

var _charTypesEnum = require('../constants/charTypesEnum');

var _charTypesEnum2 = _interopRequireDefault(_charTypesEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function removeSelectedRange(_ref) {
    var value = _ref.value,
        selection = _ref.selection,
        reformat = _ref.reformat,
        mask = _ref.mask,
        maskChar = _ref.maskChar,
        maskString = _ref.maskString;

    var copyMaskChar = function copyMaskChar(count) {
        var res = [];
        for (var i = 0; i < count; i++) {
            res.push({
                char: maskChar,
                type: _charTypesEnum2.default.MASK
            });
        }
        return res;
    };

    var pasteMaskSymbols = function pasteMaskSymbols() {
        if (reformat) {
            return '';
        }

        if (maskString) {
            var res = [];
            for (var i = selection.start; i < selection.end; i++) {
                res.push({
                    char: maskString[i],
                    type: _charTypesEnum2.default.MASK
                });
            }
            return res;
        }

        return copyMaskChar(selection.end - selection.start);
    };

    if (selection.end < selection.start) {
        var tmp = selection.end;
        selection.end = selection.start;
        selection.start = tmp;
    }

    if (selection.start === selection.end) {
        return value;
    }

    if (value.length > selection.start) {
        return value.slice(0, selection.start).concat(pasteMaskSymbols(), value.slice(selection.end, value.length));
    }

    return value;
}